import React from 'react';
import './Style.css';

const Index = ({ subtotal, shipping, credit }) => {
    return (
        <div
            style={{
                overflowY: 'hidden',
                overflowX: 'auto',
                padding: '1rem',
            }}
        >
            <table className="payment_details_table">
                <thead className="payment_details_table_head">
                    <tr className="payment_details_table_head_row">
                        <td className="payment_details_table_head_data">Subtotal</td>
                        <td className="payment_details_table_head_data">Shipping</td>
                        <td className="payment_details_table_head_data">Total</td>
                        <td className="payment_details_table_head_data">Total Payable</td>
                        <td className="payment_details_table_head_data">Available Credits</td>
                    </tr>
                </thead>
                <tbody className="payment_details_table_body">
                    <tr className="payment_details_table_body_row">
                        <td className="payment_details_table_body_data">Rs. {subtotal}</td>
                        <td className="payment_details_table_body_data">Rs. {shipping}</td>
                        <td className="payment_details_table_body_data">Rs. {shipping + subtotal}</td>
                        <td className="payment_details_table_body_data">Rs. {shipping + subtotal - credit}</td>
                        <td className="payment_details_table_body_data">Rs. {credit}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Index;
